import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { LogoPlayerFullWhite } from '@dsny/dsny-component-library'
import { useTranslation } from 'react-i18next'
import LanguageDropdown from 'components/Dropdowns/LanguageDropdown/LanguageDropdown'
import Config from 'config'
import {
  RESPONSIVE_BREAKPOINT_VERSIONS,
  useResponsiveBreakpointsVersion
} from 'contexts/ResponsiveBreakpointsContext'
import LanguageService from 'services/LanguageService'
import { LoginWrapper, LoginFooter, Link, LoginContainer } from './Auth.styles'

export default function AuthLayout({ children }) {
  const { t } = useTranslation()
  const [languages, setLanguages] = useState([])
  const responsiveBreakpointsVersion = useResponsiveBreakpointsVersion()
  const responsiveBreakpointsV2 =
    responsiveBreakpointsVersion === RESPONSIVE_BREAKPOINT_VERSIONS.V2

  const languageOptions = languages.map((lang, index) => (
    <option key={`${lang.name} ${index + 1}`} value={lang.code}>
      {lang.name}
    </option>
  ))

  useEffect(() => {
    LanguageService.getLanguages()
      .then((availableLanguages) => setLanguages(availableLanguages))
      .catch((e) => console.error(e))
  }, [])

  return (
    <LoginWrapper>
      <LanguageDropdown languageOptions={languageOptions} />
      <LoginContainer $responsiveBreakpointsV2={responsiveBreakpointsV2}>
        <div style={{ marginBottom: 18 }}>
          <LogoPlayerFullWhite />
        </div>

        {children}
      </LoginContainer>

      <LoginFooter>
        <Link href={Config.endpoints.supportURL}>{t('general.support')}</Link>
        <Link href={Config.endpoints.privacyPolicyLink}>
          {t('general.privacy')}
        </Link>
        <Link href={Config.endpoints.aboutLink}>{t('general.company')}</Link>
      </LoginFooter>
    </LoginWrapper>
  )
}

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired
}
